import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RiArrowLeftSLine, RiAddLine, RiSearchLine } from 'react-icons/ri';
import '../styles/CustomTokens.css';

const CustomTokens = () => {
  const navigate = useNavigate();
  const [tokens, setTokens] = React.useState([]);

  return (
    <div className="custom-tokens-page">
      <header className="page-header">
        <button className="back-button" onClick={() => navigate('/home')}>
          <RiArrowLeftSLine />
        </button>
        <h1>Custom tokens</h1>
        <button className="add-button" onClick={() => navigate('/add-custom-token')}>
          <RiAddLine />
        </button>
      </header>

      <div className="search-container">
        <RiSearchLine className="search-icon" />
        <input
          type="text"
          placeholder="Search by name or paste address"
          className="search-input"
        />
      </div>

      {tokens.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <path
                d="M36 12H12v24h24V12zM12 8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4H12z"
                fill="#2B5AFF"
                fillOpacity="0.5"
              />
              <path
                d="M30 22H18v4h12v-4z"
                fill="#2B5AFF"
              />
            </svg>
          </div>
          <div className="empty-text">
            <p>Custom tokens haven't been added.</p>
            <p>You can search for tokens<br />or add them manually</p>
          </div>
        </div>
      ) : (
        <div className="tokens-list">
          {/* Token list items will go here */}
        </div>
      )}

      <button 
        className="add-token-button"
        onClick={() => navigate('/add-custom-token')}
      >
        Add custom tokens <RiAddLine />
      </button>
    </div>
  );
};

export default CustomTokens;
